import { Autoplay, Navigation, Pagination, Keyboard, EffectFade, Mousewheel } from "swiper";


export const groupSlideroptions = {
  modules: [Navigation, Pagination, Autoplay, EffectFade],
  slidesPerView: 1,
  slidesPerGroup: 1,
  spaceBetween: 18,
  grabCursor: true,
  speed: 1500,
  navigation: {
    nextEl: ".group-slider .swiper-button-next",
    prevEl: ".group-slider .swiper-button-prev",
  },
  pagination: {
    el: ".image-swiper-pagination",
    type: "fraction",
  },
  autoplay: false,
  on: {
    init: function () {
      const paginationCurrent = document.querySelector(".group-slider .swiper-pagination-fraction .swiper-pagination-current") as HTMLElement;
      paginationCurrent.nextSibling?.replaceWith(" | ");
    }
  },
  breakpoints: {
    640: {
      slidesPerView: 1,
      slidesPerGroup: 1,
    },
    768: {
      slidesPerView: 1,
      slidesPerGroup: 1,
    },
    1024: {
      slidesPerView: 2,
      slidesPerGroup: 1,
    },
    1920: {
      slidesPerView: 3,
      slidesPerGroup: 1,
    },
  },
}

